import React, { useState } from 'react';

const TestimonialCard = ({ testimonial, index }) => {
  // Estado LOCAL para cada card - esto es la clave
  const [isExpanded, setIsExpanded] = useState(false);

  const truncateText = (text, maxLength = 120) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const isTextTruncated = testimonial.testimonialText.length > 120;

  return (
    <div
      className="group bg-white rounded-3xl p-8 md:p-10 testimonial-card animate-fadeInUp shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 flex flex-col relative min-h-[420px]"
      style={{ animationDelay: testimonial.delay || `${0.6 + index * 0.1}s` }}
    >
      {/* Decorative quote icon */}
      <div className="absolute top-4 right-4 text-purple-200 text-6xl opacity-50 group-hover:opacity-70 transition-opacity">
        <i className="fas fa-quote-right"/>
      </div>
      
      {/* Stars */}
      <div className="flex text-yellow-400 mb-6 relative z-10">
        <div className="flex gap-1">
          {[...Array(5)].map((_, i) => (
            <i key={i} className={`fas fa-star ${i < Math.floor(testimonial.rating) ? 'text-yellow-400' : 'text-gray-300'}`}></i>
          ))}
        </div>
      </div>

      {/* Testimonial Text and Button Container */}
      <div className="flex-1 flex flex-col relative z-10">
        {/* Testimonial Text */}
        <div className="text-gray-700 text-lg md:text-xl leading-relaxed mb-4 font-medium transition-all duration-300 ease-in-out">
          "{isExpanded ? testimonial.testimonialText : truncateText(testimonial.testimonialText)}"
        </div>
        
        {/* Read More/Less Button */}
        {isTextTruncated && (
          <button
            onClick={handleToggle}
            className="text-purple-600 hover:text-purple-700 font-medium text-sm md:text-base transition-all duration-300 ease-in-out flex items-center gap-1"
          >
            {isExpanded ? (
              <>
                <i className="fas fa-chevron-up transition-transform duration-300"></i>
                Leer menos
              </>
            ) : (
              <>
                <i className="fas fa-chevron-down transition-transform duration-300"></i>
                Leer más
              </>
            )}
          </button>
        )}
      </div>

      {/* Customer Info */}
      <div className="flex items-center pt-8 border-t border-gray-100 relative z-10">
        <div className="relative">
          <div className="w-14 h-14 rounded-full bg-gradient-to-br from-purple-100 to-pink-100 flex items-center justify-center border-3 border-purple-200 flex-shrink-0">
            <i className="fas fa-user text-purple-600 text-2xl"></i>
          </div>
          <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-green-400 rounded-full border-2 border-white flex items-center justify-center">
            <i className="fas fa-check text-white text-xs"></i>
          </div>
        </div>
        <div className="ml-4">
          <h4 className="font-bold text-gray-800 text-lg">
            {testimonial.customerName}
          </h4>
          <p className="text-sm text-purple-600 font-medium">Cliente Satisfecho</p>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
